meedy.factory('meedy.secondDiagnosisModel', ['$rootScope', 'meedy.baseModel', 'meedy.secondDiagnosisService',
    function($rootScope, baseModel, secondDiagnosisService) {

        function SecondDiagnosisModel() {

            var self = this;

            this.startWork = function(idSecondDiagnosis) {
                secondDiagnosisService.startWork(idSecondDiagnosis).then(
                    function (dataPage) {
                        $rootScope.$broadcast(Event.MEEDY.SECOND_DIAGNOSIS.START_WORK.SUCCESS, dataPage);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.SECOND_DIAGNOSIS.START_WORK.ERROR, error);
                        baseModel.broadcastOperationFailed();
                    }
                )
            };

            this.getDataPage = function(criteria) {
                secondDiagnosisService.getDataPage(criteria).then(
                    function (dataPage) {
                        $rootScope.$broadcast(Event.MEEDY.SECOND_DIAGNOSIS.GET_DATA_PAGE.SUCCESS, dataPage);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.SECOND_DIAGNOSIS.GET_DATA_PAGE.ERROR, error);
                        baseModel.broadcastOperationFailed();
                    }
                )
            };

            this.saveOrUpdate = function(idSecondDiagnosis, secondDiagnosisExecutionWrapper) {
                secondDiagnosisService.saveOrUpdate(idSecondDiagnosis, secondDiagnosisExecutionWrapper).then(
                    function (role) {
                        $rootScope.$broadcast(Event.MEEDY.SECOND_DIAGNOSIS.SAVE_OR_UPDATE.SUCCESS, role);
                        baseModel.broadcastOperationSucceeded();
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.SECOND_DIAGNOSIS.SAVE_OR_UPDATE.ERROR, error);
                        baseModel.broadcastOperationFailed();
                    }
                )
            };

            this.refuse = function(idSecondDiagnosis, secondDiagnosisRefusalWrapper) {
                secondDiagnosisService.refuse(idSecondDiagnosis, secondDiagnosisRefusalWrapper).then(
                    function (savedRole) {
                        $rootScope.$broadcast(Event.MEEDY.SECOND_DIAGNOSIS.REFUSE.SUCCESS, savedRole);
                        baseModel.broadcastOperationSucceeded();
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.SECOND_DIAGNOSIS.REFUSE.ERROR, error);
                        baseModel.broadcastOperationFailed();
                    }
                )
            };

            this.refuseIncompetence = function(idSecondDiagnosis, secondDiagnosisRefusalWrapper) {
                secondDiagnosisService.refuseIncompetence(idSecondDiagnosis, secondDiagnosisRefusalWrapper).then(
                    function (savedRole) {
                        $rootScope.$broadcast(Event.MEEDY.SECOND_DIAGNOSIS.REFUSE.SUCCESS, savedRole);
                        baseModel.broadcastOperationSucceeded();
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.SECOND_DIAGNOSIS.REFUSE.ERROR, error);
                        baseModel.broadcastOperationFailed();
                    }
                )
            };

            this.token = function(idSecondDiagnosis) {
                secondDiagnosisService.token(idSecondDiagnosis).then(
                    function (token) {
                        $rootScope.$broadcast(Event.MEEDY.SECOND_DIAGNOSIS.TOKEN.SUCCESS, token);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.SECOND_DIAGNOSIS.TOKEN.ERROR, error);
                        baseModel.broadcastOperationFailed();
                    }
                )
            };

            this.downloadPDF = function(token) {
                secondDiagnosisService.downloadPDF(token).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.SECOND_DIAGNOSIS.DOWNLOAD_PDF.SUCCESS, data);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.SECOND_DIAGNOSIS.DOWNLOAD_PDF.ERROR, error);
                        baseModel.broadcastOperationFailed();
                    }
                )
            };

            this.execute = function(idSecondDiagnosis, secondDiagnosisExecutionWrapper) {
                secondDiagnosisService.execute(idSecondDiagnosis, secondDiagnosisExecutionWrapper).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.SECOND_DIAGNOSIS.EXECUTE.SUCCESS, data);
                        baseModel.broadcastOperationSucceeded();
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.SECOND_DIAGNOSIS.EXECUTE.ERROR, error);
                        baseModel.broadcastOperationFailed();
                    }
                )
            };

            this.getById = function(idSecondDiagnosis) {
                secondDiagnosisService.getById(idSecondDiagnosis).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.SECOND_DIAGNOSIS.GET_BY_ID.SUCCESS, data);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.SECOND_DIAGNOSIS.GET_BY_ID.ERROR, error);
                    }
                )
            };

            this.getAttachments = function(idSecondDiagnosis) {
                secondDiagnosisService.getAttachments(idSecondDiagnosis).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.SECOND_DIAGNOSIS.GET_ATTACHMENTS.SUCCESS, data);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.SECOND_DIAGNOSIS.GET_ATTACHMENTS.ERROR, error);
                    }
                )
            };

            this.downloadSelectedAttachments = function(idSecondDiagnosis, wrapper) {
                secondDiagnosisService.downloadSelectedAttachments(idSecondDiagnosis, wrapper).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.SECOND_DIAGNOSIS.DOWNLOAD_ATTACHMENT.SUCCESS, data);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.SECOND_DIAGNOSIS.DOWNLOAD_ATTACHMENT.ERROR, error);
                    }
                )
            };

            this.downloadAttachment = function(idSecondDiagnosis, idAttachment, name) {
                secondDiagnosisService.downloadAttachment(idSecondDiagnosis, idAttachment, name).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.SECOND_DIAGNOSIS.DOWNLOAD_ATTACHMENT.SUCCESS, data);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.SECOND_DIAGNOSIS.DOWNLOAD_ATTACHMENT.ERROR, error);
                    }
                )
            };

        }

        return new SecondDiagnosisModel();
    }
]);
